import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function WhatYouGet() {
  const items = [{
    title: 'Guía Maestra Protocolo Dopamina Cero',
    desc: 'El manual paso a paso con la ciencia y la estrategia de ejecución.'
  }, {
    title: 'Plan de Choque de 72 Horas',
    desc: 'El protocolo exacto para sobrevivir a los tres días más críticos de abstinencia.'
  }, {
    title: 'La Regla de los 5 Segundos de Interrupción',
    desc: 'La técnica física para detener el impulso antes de que se convierta en acción.'
  }, {
    title: 'Tracker de 21 Días (Printable)',
    desc: 'Tu hoja de ruta visual para marcar cada victoria y ver tu progreso real.'
  }, {
    title: 'Guía de Habitación Blindada',
    desc: 'Cómo rediseñar tus espacios físicos para que la recaída sea casi imposible.'
  }];
  return <section className="py-20 px-6 bg-[#09090b]" data-id="element-165">
      <div className="max-w-3xl mx-auto" data-id="element-166">
        <FadeIn data-id="element-167">
          <h2 className="font-bebas text-4xl sm:text-5xl uppercase tracking-wide text-center mb-12" data-id="element-168">
            Lo que <span className="text-amber-500" data-id="element-169">obtienes</span>
          </h2>
        </FadeIn>

        <div className="grid gap-4" data-id="element-170">
          {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-171">
              <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 sm:p-8 flex gap-5 hover:border-amber-500/30 transition-colors" data-id="element-172">
                <div className="mt-1" data-id="element-173">
                  <CheckCircle2Icon className="w-6 h-6 text-amber-500" data-id="element-174" />
                </div>
                <div data-id="element-175">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-176">
                    {item.title}
                  </h3>
                  <p className="text-zinc-400 leading-relaxed" data-id="element-177">{item.desc}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}